import { GridRow } from "./Grid";
import { SquareValue  } from "./Values";
import { RestartButton, SettingsButton, HelpButton } from "./uw-online-shared/UwOnlineComponents";

function Title() {
    return (
        <div style={{display: "flex", alignContent:"end"}}>
            <GridRow letters={SquareValue.arrayFromLetters("GOGEN")} size="25" row="0"/>
            <div style={{display:"flex", flexDirection: "column", justifyContent:"end"}}>
                <div style={{height: "1em", paddingBottom: "0.2em", marginLeft: "-5px", fontSize:"15px", fontWeight: "bold"}}>.ONLINE</div>
            </div>
     </div>
    )
}

export function DesktopNav(props) {

    return(
        <nav class="desktop-nav">
            <Title/>
            <MainPopupButtons 
                settingsPopup={props.settingsPopup} 
                helpPopup={props.helpPopup}
                restartConfirmPopup={props.restartConfirmPopup}
                restartEnabled={props.restartEnabled}
                colourCode="007700"
                disabledColourCode="7de0b6"
            />
        </nav>
    );

}

export function TabletNav(props) {

    return(
        <nav class="desktop-nav">
            <Title/>
            <MainPopupButtons 
                settingsPopup={props.settingsPopup} 
                helpPopup={props.helpPopup}
                restartConfirmPopup={props.restartConfirmPopup}
                restartEnabled={props.restartEnabled}
                colourCode="007700"
                disabledColourCode="7de0b6"
            />
        </nav>
    );


}

export function MobileNav(props) {
    return(
        <nav class="desktop-nav">
            <Title/>
            <MainPopupButtons 
                settingsPopup={props.settingsPopup} 
                helpPopup={props.helpPopup}
                restartConfirmPopup={props.restartConfirmPopup}
                restartEnabled={props.restartEnabled}
                colourCode="007700"
                disabledColourCode="7de0b6"
            />
        </nav>
    );
}

export function MainPopupButtons(props) {
    console.log("MainPopupButtons; colourCode: "+props.colourCode)
    return (
        <div style={{display: "flex", justifyContent:"space-evenly", width: "200px"}}>
            <RestartButton popup={props.restartConfirmPopup} enabled={props.restartEnabled} colourCode={props.colourCode} disabledColourCode={props.disabledColourCode}/>
            <SettingsButton popup={props.settingsPopup} colourCode={props.colourCode} />
            <HelpButton popup={props.helpPopup} colourCode={props.colourCode} />
        </div>
    )
}
